import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    hasTrinDocsLicense: false,
    hasTrinFormsLicense: false,
    isValid: false,
    isExpired: false,
    expDate: "",
    trinDocsLicense: {},
    trinFormsLicense: {},
    loaded: false
  }
};
const licenseSlice = createSlice({
  name: "license",
  initialState,
  reducers: {
    loadActiveLicenses: (state, action) => {
      state.value = {
        hasTrinDocsLicense: action.payload.hasTrinDocsLicense,
        hasTrinFormsLicense: action.payload.hasTrinFormsLicense,
        isValid: action.payload.isValid,
        isExpired: action.payload.isExpired,
        expDate: action.payload.expDate,
        trinDocsLicense: action.payload.trinDocsLicense,
        trinFormsLicense: action.payload.trinFormsLicense,
        loaded: true
      };
    }
  }
});
export const { loadActiveLicenses } = licenseSlice.actions;
export default licenseSlice.reducer;
